export default "__VITE_ASSET__7s7XEN9A__"